import $ from 'jquery';

$('.postalcodeLookup').focusout(
    function (event) {
        if ($(this).val() !== "") {
            $.getJSON("https://api.dataforsyningen.dk/postnumre/" + $(this).val(),
                function (data) {
                    $("#" + $(event.currentTarget).data('target')).val(data.navn);
                }
            );
        }
    }
);
